<template>
  <v-data-table v-model="selected" :headers="headers" :items="items" :items-per-page="itemsPerPage" :options.sync="options"
    :search="searchQuery" @update:page="fetchPlaylist" @update:items-per-page="updateItemsPerPage" :loading="loading"
    :item-key="items.id" :footer-props="footerProps" :server-items-length="totalItems" show-select
    class="data-table elevation-0">
    <template #[`item.image`]="{ item }">
      <div class="image-container ma-1">
        <img :src="item.image"
          style="position: absolute; height: 100%; top: 0; object-fit: contain; object-position: top center;padding: 0;"
          :contain="true" />
      </div>
    </template>
    <template v-slot:item.groupNames="{ item }">

          <template v-for="(groupName, index) in item.groupNames.slice(0, 3)">
            <span :key="index" :style="{ backgroundColor: generateColor(groupName) }" class="playlist_group">
              {{ groupName }}
            </span>
          </template>

          <span v-if="item.groupNames.length > 3" class="playlist_group_more">
            + {{ item.groupNames.length - 3 }}
          </span>


    </template>

  </v-data-table>

</template>
<script>
import PlaylistApi from "@/api/playlist/PlaylistApi";
import { mapActions, mapGetters, mapState } from 'vuex';
import GroupChip from "@/components/ui/chips/Chip.vue";

export default {
  components: {
    GroupChip
  },
  data() {
    return {
      //headers: [
      //  { text: this.$store.getters.t('썸네일'), value: 'image' },
      //  { text: this.$store.getters.t('파일 이름'), value: 'name' },
      //  { text: this.$store.getters.t('그룹'), value: 'groupNames' },
      //  { text: this.$store.getters.t('재생 시간'), value: 'runtime' },
      //],
      //selectedGroup: [],
      items: [],
      cachedPlaylists: {},
      currentPage: 1,
      totalItems: 0,
      groupNames: null,
      showGroupDialog: false,
      showAllListDialog: false,
      loading: false,
      itemsPerPage: 10,
      footerProps: {
        itemsPerPageOptions: [10, 15],
        itemsPerPageText: '',
        page: 1,
        pageStart:1,
        itemsPerPage: 10,
        totalItems: 0,
      },
      options: {
        page: 1,
        itemsPerPage: 10,
      },

    }
  },
  computed: {
    headers() {
      return this.$store.getters['objectData/getHeaders']('playlist');
    },
    groupId() {
      return this.$store.state.group.selectedGroupId;
    },
    ...mapState('search', ['searchQuery']),
    groupName() {
      return this.$store.state.group.selectedGroupName;
    },
    ...mapGetters('group', ['selectedItems']),
    selected: {
      get() {
        return this.$store.state.group.selectedItems;
      },
      set(value) {
        this.$store.dispatch('group/updateSelectedItems', value);
      }
    },
    groupingCompleted() {
      return this.$store.state.group.groupingCompleted;
    },
    ...mapState('group', {
      deleteStatus: state => state.deleteStatus,
      modifyStatus: state => state.modifyStatus,
    }),
    itemCount(){
      return this.$store.getters.t('항목 수');
    }
  },
  methods: {
    ...mapActions('group', ['updateSelectedGroupId', 'updateSelectedGroupName', 'updateSelectedItems']),
    ...mapActions('search', ['resetSearch']),
    async fetchPlaylist(page = this.options.page, itemsPerPage = this.options.itemsPerPage) {
      this.loading = true;
      this.options.page = page;
      this.options.itemsPerPage = itemsPerPage;
      this.updateFooterProps();
      try {
        const response = await PlaylistApi.allPlaylistApi(this.options.page, this.options.itemsPerPage, this.searchQuery );
        // console.log('response', response);
        const processedData = response.data.map(item => ({
          id: item.id,
          name: item.name,
          runtime: item.runtime,
          // groupNames: item.group_names,
          groupNames: Object.values(item.group_names),
          image: item.posterImg ? item.posterImg : "https://ceph01rgw.streamon.co.kr:47043/streamon01/logo/streamon.png",
        }));
        //this.cachedPlaylists[cacheKey] = processedData;
        this.totalItems = parseInt(response.total, 10);
        // console.log('totalItems', this.totalItems);
        this.items = processedData;
        this.updateFooterProps();

      } catch (error) {
        console.error('error', error);

      } finally {
        this.loading = false;
      }
    },
    updateFooterProps() {
      this.footerProps = {
        itemsPerPageOptions: [10, 15],
        itemsPerPageText: this.itemCount,
        page: this.options.page,
        itemsPerPage: this.options.itemsPerPage,
        totalItems: this.totalItems,
      };
    },
    updateItemsPerPage(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.fetchPlaylist(1, itemsPerPage);
    },
    navigateToGroup(groupId, page = 1) {
      this.$router.push({ name: 'playlist', query: { group_id: groupId, page } });
    },
    forceRefresh() {
      this.fetchPlaylist(this.currentPage, 10);
    },
    generateColor(groupName) {
      const hashCode = s => {
        let h = 0;
        for (let i = 0; i < s.length; i++) {
          h = Math.imul(31, h) + s.charCodeAt(i) | 0;
        }
        return h;

      };

      let extendedName = groupName;
      while (extendedName.length < 6) {
        extendedName += groupName;
      }

      let colorInt = (hashCode(extendedName) & 0xFFFFFF).toString(16);

      // Ensure the color is 6 characters long
      colorInt = colorInt.padStart(6, '0');

      const color = `#${colorInt}`;
      return color;
    },
  },
  mounted() {
    this.resetSearch(); 
    this.updateSelectedGroupId('all');
  },
  watch: {
    groupId: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal && newVal === 'all' && this.deleteStatus === false) {
          //console.log('groupId changed to:', newVal);
          this.options.page = 1;
          this.options.itemsPerPage = 10;
          this.resetSearch(); 
          this.fetchPlaylist(this.options.page, this.options.itemsPerPage);
        }
      },
      immediate: true,
      deep: true
    },
    searchQuery: {
      handler(newQuery) {
        //console.log('newQuery', newQuery);
        this.fetchPlaylist(1, this.itemsPerPage, newQuery);
      },
      immediate: true,
    },
    selected: {
      handler(newVal) {
        //console.log('new', newVal);
        this.updateSelectedItems(newVal);
      },
      deep: true,
      immediate: true,
    },
    groupingCompleted(newValue) {
      //console.log('groupingCompleted', newValue);
      if (newValue === true) {
        this.options.page = 1;
        this.options.itemsPerPage = 10;
        this.resetSearch(); 
        this.fetchPlaylist(1, 10);

      }
    },
    deleteStatus(newStatus) {
      //console.log('new', newStatus);
      if (newStatus) {
        this.forceRefresh();
        this.$store.dispatch('group/reportDeleteStatus', false);
      }
    },
    modifyStatus(newStatus) {
      //console.log('new', newStatus);
      if (newStatus) {
        this.forceRefresh();
        this.$store.dispatch('group/reportModifyStatus', false);
      }
    },
    itemCount(newVal){
      this.footerProps.itemsPerPageText = newVal;
    }
  }
};
</script>

<style>
.dragArea {
  border: 1px solid #eee;
}

.image-container {
  position: relative;
  background-color: black;
  width: 107px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 6px;
}

.playlist_group {
  color: #fff;
  opacity: 0.8;
  padding: 4px 8px;
  border-radius: 4px;
  margin-right: 4px;
  font-size: 11px;
  width: 70px;
  display:inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.playlist_group_more{
    color: #aaa;
    font-size: 12px;
    height: 20px;
}
</style>
